import { render, staticRenderFns } from "./HspRoleAdminLayout.vue?vue&type=template&id=8b0f34bc"
import script from "./HspRoleAdminLayout.vue?vue&type=script&lang=js"
export * from "./HspRoleAdminLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports